import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'components/Firebase/index.js';
import { useAlert } from 'contexts/AlertContext.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import useOrgId from 'hooks/useOrgId.js';

const useUserDataQuery = () => {
  const { t } = useLocalization();
  const firebase = useFirebase();
  const user = firebase.auth.currentUser;
  const isSignedIn = Boolean(user);
  const orgId = useOrgId();
  const masqueradeMode = useSelector((state) => state.ui.masqueradeMode);
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const { setAlert } = useAlert();

  const isQueryEnabled = !!(orgId && uid && !masqueradeMode && isSignedIn && orgId !== 'no-team');

  return useQuery({
    queryKey: ['o', orgId, 'user', uid],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const { body } = await agent.get(`/o/${orgId}/users/${uid}`);

      return {
        fullName: body.user.fullName || '',
        displayName: body?.orgUser?.displayName || '',
        avatar: body?.orgUser?.avatar?.url || null,
        jobTitle: body?.orgUser?.jobTitle || '',
        email: body?.orgUser?.email || body.user.email || '',
        calendarId: body?.orgUser?.calendarId || '',
        calendars: body?.orgUser?.calendars || [],
        roles: body?.orgUser?.roles || [],
        locale: body?.user?.locale || '',
        optOutPlatformEmails: body?.orgUser?.optOutPlatformEmails || false,
      };
    },
    onError: (error) => {
      console.error(error);
      setAlert({ title: t('genericLabels.error'), variant: 'danger' });
    },
    onSettled: (data, error) => {},
    enabled: isQueryEnabled,
  });
};

useUserDataQuery.propTypes = {

};

export default useUserDataQuery;
